export const PAGE_DATA_REVALIDATED = 'Page Data has been revalidated';
export const SET_INITIAL_PAGE_DATA = 'Set Initial Page Data';
export const SET_INITIAL_PAGE_ERROR = 'Set Initial Page Error';
